/**
 * Chart color palette for dynamic data rendering
 * Uses Ant Design theme colors for dark mode compatibility
 * Note: These are fallback values - prefer using getChartColors() for runtime theme colors
 */export const CHART_COLORS=['#1677ff',// Blue
'#fa8c16',// Orange
'#722ed1',// Purple
'#52c41a',// Green
'#eb2f96',// Magenta
'#13c2c2',// Cyan
'#faad14',// Gold
'#a0d911'// Lime
];/**
 * Get chart colors from CSS variables (theme-aware)
 * This ensures colors work in both light and dark mode
 */export function getChartColors(){// Try to get colors from CSS variables first
if(typeof window!=='undefined'&&typeof getComputedStyle!=='undefined'){const rootStyle=getComputedStyle(document.documentElement);const colorPrimary=rootStyle.getPropertyValue('--ant-color-primary').trim();const colorInfo=rootStyle.getPropertyValue('--ant-color-info').trim();const colorSuccess=rootStyle.getPropertyValue('--ant-color-success').trim();const colorWarning=rootStyle.getPropertyValue('--ant-color-warning').trim();if(colorPrimary){return[colorPrimary,colorWarning,'#722ed1',// Purple (Ant doesn't have a standard purple)
colorSuccess,'#eb2f96',// Magenta
colorInfo,'#faad14',// Gold
'#a0d911'// Lime
];}}// Fallback to static colors
return CHART_COLORS;}/**
 * Get color from palette by index (cycles through if > 8 items)
 * Uses theme-aware colors when available
 */export function getColor(index){const colors=getChartColors();return colors[index%colors.length];}/**
 * Get color based on growth value
 */export function getGrowthColor(value){if(value===null||value===undefined)return'var(--ant-color-text-secondary)';if(value>0)return'var(--ant-color-success)';if(value<0)return'var(--ant-color-error)';return'var(--ant-color-warning)';}/**
 * Get heat map color for Trends grid based on MoM growth
 * Green for positive growth, red for decline
 */export function getTrendsHeatMapColor(momGrowth){if(momGrowth===null||momGrowth===undefined)return'transparent';// Green for positive growth (higher opacity = stronger growth)
if(momGrowth>20)return'rgba(82, 196, 26, 0.3)';// Strong growth
if(momGrowth>10)return'rgba(82, 196, 26, 0.2)';// Good growth
if(momGrowth>5)return'rgba(82, 196, 26, 0.1)';// Moderate growth
if(momGrowth>0)return'rgba(82, 196, 26, 0.05)';// Slight growth
// Red for decline (higher opacity = stronger decline)
if(momGrowth<-20)return'rgba(255, 77, 79, 0.3)';// Strong decline
if(momGrowth<-10)return'rgba(255, 77, 79, 0.2)';// Significant decline
if(momGrowth<-5)return'rgba(255, 77, 79, 0.1)';// Moderate decline
if(momGrowth<0)return'rgba(255, 77, 79, 0.05)';// Slight decline
// Exactly 0% growth
return'transparent';}/**
 * Get heat map color for grid cells (theme-aware)
 * Returns rgba values that work in both light and dark modes
 * @deprecated Use getTrendsHeatMapColor for Trends grid
 */export function getHeatMapColor(value,average){if(!value||!average)return'transparent';const ratio=value/average;// Use rgba with theme-aware colors
if(ratio>1.5)return'rgba(82, 196, 26, 0.2)';// High green (success color with opacity)
if(ratio>1.2)return'rgba(82, 196, 26, 0.1)';// Medium green
if(ratio>0.8)return'transparent';// Normal
if(ratio>0.5)return'rgba(255, 77, 79, 0.1)';// Light red
return'rgba(255, 77, 79, 0.2)';// High red (error color with opacity)
}/**
 * Get severity color for operational issues
 */export function getSeverityColor(severity){const severityLower=severity.toLowerCase();if(severityLower.includes('critical'))return'red';if(severityLower.includes('high'))return'orange';if(severityLower.includes('medium'))return'gold';if(severityLower.includes('low'))return'blue';return'default';}/**
 * Get background color for currency cards (subtle variations)
 */export function getCurrencyBgColor(index){const colors=['#e6f4ff',// Blue tint
'#fff7e6',// Orange tint
'#f9f0ff',// Purple tint
'#f6ffed',// Green tint
'#fff0f6',// Magenta tint
'#e6fffb',// Cyan tint
'#fffbe6',// Gold tint
'#fcffe6'// Lime tint
];return colors[index%colors.length];}/**
 * Get issue type badge color
 */export function getIssueTypeColor(issueType){const types={expired_active_agreements:'red',no_subscription:'orange',churned_with_active_ea:'magenta',active_with_unsubscribed:'volcano'};return types[issueType]||'default';}